export default __webpack_public_path__ + "static/media/media-rueda.cfb58eb3.svg";